/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsdescription1Inputs */

const id_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set pencapaian, status tersembunyi, distribusi kelangkaan, dan total XP yang dilampirkan ke sandbox ini.`)
};

const ms_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set pencapaian, status tersembunyi, taburan kecelaruan, dan jumlah XP yang dilampirkan pada sandbox ini.`)
};

const da_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement-sæt, skjulte statusser, sjældenhedsfordeling og XP-totaler tilknyttet denne sandbox.`)
};

const de_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften-Sets, versteckte Status, Seltenheitsverteilung und XP-Gesamtsummen dieser Sandbox.`)
};

const en_us2_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievement sets, hidden states, rarity distribution, and XP totals attached to this sandbox.`)
};

const es_es2_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de logros, estados ocultos, distribución de rareza y totales de XP adjuntos a este sandbox.`)
};

const es_mx2_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de logros, estados ocultos, distribución de rareza y totales de XP adjuntos a este sandbox.`)
};

const fil_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga set ng achievement, hidden states, distribution ng rarity, at XP totals na naka-attach sa sandbox na ito.`)
};

const fr_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensembles de succès, états cachés, distribution de rareté et totaux XP attachés à ce sandbox.`)
};

const it_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set di risultati, stati nascosti, distribuzione della rarità e totali XP allegati a questo sandbox.`)
};

const hu_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítménykészletek, rejtett állapotok, ritkaságeloszlás és XP-összegek ehhez a sandbox-hoz csatolva.`)
};

const nl_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestatiesets, verborgen statussen, zeldzaamheidsverdeling en XP-totalen die aan deze sandbox zijn gekoppeld.`)
};

const no_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjonssett, skjulte tilstander, sjeldenhetsfordeling og XP-totaler knyttet til denne sandboxen.`)
};

const pl_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zestawy osiągnięć, ukryte stany, rozkład rzadkości i sumy XP przypisane do tego sandboxa.`)
};

const pt_br2_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de conquistas, estados ocultos, distribuição de raridade e totais XP anexados a esta sandbox.`)
};

const pt_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de conquistas, estados ocultos, distribuição de raridade e totais de XP associados a esta sandbox.`)
};

const ro_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seturi de realizări, stări ascunse, distribuție raritate și totaluri XP atașate acestui sandbox.`)
};

const fi_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutussarjat, piilotetut tilat, harvinaisuusjakauma ja XP-kokonaismäärät liitettynä tähän hiekkalaatikkoon.`)
};

const sv_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationsuppsättningar, dolda tillstånd, sällsynthetsfördelning och XP-summor kopplade till denna sandlåda.`)
};

const vi_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ thành tích, trạng thái ẩn, phân bố độ hiếm và tổng XP gắn liền với sandbox này.`)
};

const tr_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sandbox'a bağlı başarım setleri, gizli durumlar, nadirlik dağılımı ve XP toplamları.`)
};

const cs_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sady úspěchů, skryté stavy, rozložení vzácnosti a celkové XP připojené k tomuto sandboxu.`)
};

const bg_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набори от постижения, скрити състояния, разпределение на рядкост и общо XP, прикачени към този sandbox.`)
};

const ru_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наборы достижений, скрытые состояния, распределение редкости и общее количество опыта (XP), привязанные к этой песочнице.`)
};

const uk_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набори досягнень, приховані стани, розподіл рідкості та суми XP, прив'язані до цього Sandbox.`)
};

const ar_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعات الإنجازات والحالات المخفية وتوزيع الندرة وإجماليات XP المرتبطة بـ Sandbox هذا.`)
};

const hi_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सैंडबॉक्स से जुड़े उपलब्धि सेट, छिपी हुई अवस्थाएँ, दुर्लभता वितरण और XP कुल।`)
};

const th_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุดความสำเร็จ สถานะที่ซ่อนอยู่ การกระจายความหายาก และคะแนน XP ที่แนบกับแซนด์บ็อกซ์นี้`)
};

const ja_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサンドボックスに紐づく実績セット、非表示状態、レアリティ分布、XP 合計。`)
};

const zh_cn2_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`附加到此沙盒的成就集合、隐藏状态、稀有度分布和经验值总计。`)
};

const zh_hant1_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`附加到此沙盒的成就集合、隱藏狀態、稀有度分佈和經驗值總計。`)
};

const ko_sandboxes_achievementsdescription1 = /** @type {(inputs: Sandboxes_Achievementsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Sandbox에 연결된 도전 과제 세트, 숨김 상태, 희귀도 분포 및 XP 합계입니다.`)
};

/**
* | output |
* | --- |
* | "Achievement sets, hidden states, rarity distribution, and XP totals attached to this sandbox." |
*
* @param {Sandboxes_Achievementsdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsdescription1 = /** @type {((inputs?: Sandboxes_Achievementsdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsdescription1(inputs)
	if (locale === "da") return da_sandboxes_achievementsdescription1(inputs)
	if (locale === "de") return de_sandboxes_achievementsdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsdescription1(inputs)
	if (locale === "it") return it_sandboxes_achievementsdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsdescription1(inputs)
	if (locale === "no") return no_sandboxes_achievementsdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsdescription1(inputs)
	if (locale === "th") return th_sandboxes_achievementsdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsdescription1(inputs)
	return ko_sandboxes_achievementsdescription1(inputs)
});
export { sandboxes_achievementsdescription1 as "sandboxes.achievementsDescription" }